import React from "react";
import ImageGallery from "components/ImageGallery";
import ImageGalleryModal from "components/ImageGalleryModal";
import DenounceImageGalleryModal from "components/ImageGalleryModal/denounceImageGalleryModal";

export default function DenounceImages(props) {
  const { alt, thumbnail, images: propsImages, openModalOnClick, modal, viewMore, articleId } = props;
  const originalImages = propsImages;

  const images = React.useMemo(
    () =>
      propsImages.length
        ? propsImages.map((image) => ({
            id: image.id,
            alt: image.id,
            src: image.secure_url,
            thumbnail: image.secure_url.replace("-O.", "-R."),
          }))
        : thumbnail
        ? [
            {
              alt,
              src: thumbnail.replace("http", "https").replace("-I.", "-O."),
              thumbnail: thumbnail.replace("http", "https").replace("-I.", "-R."),
            },
          ]
        : null,
    [alt, thumbnail, propsImages]
  );

  return (
    <DenounceImageGalleryModal
      images={images}
      openModalOnClick={openModalOnClick}
      articleId={articleId}
      fallbackImage={{
        alt,
        src: "https://http2.mlstatic.com/resources/frontend/statics/img-not-available/1.0.0/V.jpg",
      }}
    />
  );
}
